import { render, staticRenderFns } from "./Terms2.vue?vue&type=template&id=37676ff0&"
import script from "./Terms2.vue?vue&type=script&lang=js&"
export * from "./Terms2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports